import React, {useEffect, useRef} from 'react';
import UseContext from "hooks/useContext";
import {NavLink, useNavigate} from "react-router-dom";
import {
    AddMission,
    ChevronLeftNav,
    ChevronRightNav,
    Plus,
} from "assets/icons";
import Logo from "assets/images/Jobbiz.svg";
import Tooltips from "components/tooltips/Tooltips";
import Button from "components/button";
import DashboardLink
    from "components/sidebar/links/dashboard.link";
import ProfilLink from "components/sidebar/links/profil.link";
import ContractLink from "components/sidebar/links/contract.link";
import InvoiceLink from "components/sidebar/links/invoice.link";
import MissionLink
    from "components/sidebar/links/mission.link";
import TimeSheetLink
    from "components/sidebar/links/timeSheet.link";
import MissionTemplateLink
    from "components/sidebar/links/missionTemplate.link";

const SidebarDesktop = () => {
    const {
        sidebarExpanded,
        setSidebarExpanded,
        sidebarOpen,
        setSidebarOpen,
        setPage,
        setMissionCostEstimate,
        roleUser,
        setSelectedMissionTemplate,
    } =
        UseContext();
    const trigger = useRef(null);
    const sidebar = useRef(null);
    const rUser = localStorage.getItem('rUser')
    const navigate = useNavigate()
    useEffect(() => {
        localStorage.setItem("sidebar-expanded", sidebarExpanded);
        if (sidebarExpanded) {
            document.querySelector("body").classList.add("sidebar-expanded");
        } else {
            document.querySelector("body").classList.remove("sidebar-expanded");
        }
    }, [sidebarExpanded]);

    useEffect(() => {
        const clickHandler = ({target}) => {
            if (!sidebar.current || !trigger.current) return;
            if (
                !sidebarOpen ||
                sidebar.current.contains(target) ||
                trigger.current.contains(target)
            )
                return;
            setSidebarOpen(false);
        };
        document.addEventListener("click", clickHandler);
        return () => document.removeEventListener("click", clickHandler);
    });
    return (
        <>
            <div
                id="sidebar"
                ref={sidebar}
                className={`flex flex-col absolute left-0 top-0 tab:static tab:left-auto tab:translate-x-0 transform h-screen overflow-y-scroll tab:overflow-y-auto no-scrollbar w-60 tab:w-[80px] tab:sidebar-expanded:!w-64 2xl:!w-64 shrink-0 bg-[#FCFCFC] p-4 transition-all duration-200 ease-in-out ${
                    sidebarOpen ? "translate-x-0" : "-translate-x-60"
                } `}
            >
                {/* Sidebar Header */}
                <div
                    className="flex justify-between mb-10 pr-3 mm:px-2">
                    {/* close Button */}
                    <button
                        className="tab:hidden text-gray-600 hover:text-slate-400"
                        onClick={() => setSidebarOpen(!sidebarOpen)}
                        aria-controls="sidebar"
                        aria-expanded={sidebarOpen}
                    >
                        <span
                            className="sr-only ">Fermer le menu</span>
                        <ChevronLeftNav/>
                    </button>
                    <NavLink
                        end
                        to="/dashboard"
                        className={`flex items-center justify-center w-24 !sidebar-expanded:hidden `}
                    >
                        <img src={Logo} alt="logo"
                             className="w-full"/>

                    </NavLink>
                    {/* Expand / collapse button */}
                    <div
                        className="pt-3 hidden tab:inline-flex 2xl:hidden justify-end mt-auto">
                        <div className="px-3 py-2 ">
                            <Tooltips
                                text={sidebarExpanded ? "Reduire" : "Agrandir"}
                                placement="right"
                            >
                                <button
                                    onClick={() => setSidebarExpanded(!sidebarExpanded)}>
                                    <span
                                        className="sr-only">Expand / collapse sidebar</span>
                                    <ChevronRightNav
                                        prop={"sidebar-expanded:rotate-180"}
                                    ></ChevronRightNav>
                                </button>
                            </Tooltips>
                        </div>
                    </div>
                </div>
                <div className="space-y-8">
                    <div>
                        <ul className="flex flex-col gap-1">
                            {(rUser !== '200' && rUser !== '205') && (
                                <div className="flex flex-col pb-4">
                                    <Button
                                        size={'LG'}
                                        color={'PRIMARY'}
                                        onClick={(e) => {
                                            navigate('/missionTemplates');
                                            setPage(3);
                                            setSelectedMissionTemplate(null);
                                            setMissionCostEstimate(0);
                                        }}
                                    >
                                        <div className="flex items-center gap-2">
                                            <div className="block sidebar-expanded:hidden">
                                                <AddMission
                                                    wh={20}
                                                    cIcon={'fill-white stroke-white '}
                                                />
                                            </div>
                                            <div className="hidden sidebar-expanded:flex sidebar-expanded:items-center sidebar-expanded:gap-2 sidebar-expanded:opacity-100 duration-200">
                                                <Plus wh={14} color={'#fff'} />
                                                <div>Créer une mission</div>
                                            </div>
                                        </div>
                                    </Button>
                                </div>
                            )}
                            {/* Links */}
                            <DashboardLink />
                            {(rUser !== '205' && rUser !== '220') && <ContractLink />}
                            {(rUser !== '205' && rUser !== '220') && <InvoiceLink />}
                            <TimeSheetLink />
                            {(rUser !== '200' && rUser !== '205') && <MissionTemplateLink />}
                            {rUser !== '205' && <MissionLink />}
                            {(rUser !== '200' && rUser !== '205' && rUser !== '210' && rUser !== '220') && <ProfilLink />}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SidebarDesktop;